import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ReportProps } from '../Components/Report'

/**
 * Translates string cells in a 2D chart data array using the provided i18n t function.
 * Non-string values are returned untouched. Result is memoized by data and t.
 */
export const useTranslateChartHeaders = ({ chartData, i18nNamespace }: Props): ReportProps['chart']['data'] | null => {
    const { t } = useTranslation(i18nNamespace)
    return useMemo(() => {
        if (!Array.isArray(chartData) || !chartData.length) return null
        const [header, ...rows] = chartData
        const translatedHeader = header.map((value) => (typeof value === 'string' ? (t(value) as string) : value))
        return [translatedHeader, ...rows]
    }, [chartData, t])
}

type Props = {
    chartData?: ReportProps['chart']['data']
    i18nNamespace?: string
}
